module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "bio"
    }
  }, [_c('v-app', {
    attrs: {
      "id": "inspire"
    }
  }, [_c('v-container', {
    staticStyle: {
      "min-height": "0"
    },
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "text-xs-center": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xl12": ""
    }
  }, [_c('v-stepper', {
    staticStyle: {
      "background-color": "transparent"
    },
    model: {
      value: (_vm.e1),
      callback: function($$v) {
        _vm.e1 = $$v
      },
      expression: "e1"
    }
  }, [_c('v-stepper-header', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('v-stepper-step', {
    attrs: {
      "step": "1"
    }
  }, [_vm._v("Name of step 1")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "step": "2"
    }
  }, [_vm._v("Name of step 2")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "step": "3"
    }
  }, [_vm._v("Name of step 3")])], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "1"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "rgba(0,0,0,1)"
    }
  }, [_c('font', {
    attrs: {
      "face": "verdana"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "rgba(0,0,0,1)",
      "font-weight": "bold"
    }
  }, [_vm._v(" Biography")])])], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "container"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "src": "/static/doc-images/lists/bio1.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-height": "200px",
      "overflow-y": "auto"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I have come to sow the seed of love in your hearts so that, in spite of all superficial diversity which your life in illusion must experience and endure, the feeling of oneness through love is brought about amongst all the nations, creeds, sects and castes of the world.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("~ Meher Baba")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("AVATAR MEHER BABA")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("(1894-1969)")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v(" ")])])]), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 2
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_next")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "2"
    }
  }, [_c('div', {
    attrs: {
      "id": "container"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/doc-images/lists/bio2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("  Baba's Family Portrait ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-height": "200px",
      "overflow-y": "auto"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Meher Baba was born Merwan Sheriar Irani in Poona, India, on February 25, 1894, of Zoroastrian parents.  His father, Sheriar, was a true and respected seeker of God. Merwan had a normal childhood, and attended a Catholic high school. Later while attending Deccan College in 1913, he was summoned by Hazrat Babajan, an ancient Muslim saint who was one of the five Perfect Masters of the Age. After seven months, Babajan unveiled Merwan’s true state of God-consciousness.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 3
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_next")])], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "left": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 1
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_before")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "3"
    }
  }, [_c('div', {
    attrs: {
      "id": "container"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "src": "/static/doc-images/lists/bio3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Five Perfect Masters")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-height": "200px",
      "overflow-y": "auto"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Eventually He was drawn to visit the other four perfect masters of the age including Sai Baba of Shirdi, who prostrated himself before Merwan shouting, “Parvardigar Ho!”  Sai sent Merwan to the Hindu Sadguru, Upasni Maharaj, who, over the next seven years, gave Merwan the divine knowledge He would need to fulfill His unique responsibility as Avatar. By that time a number of disciples from diverse backgrounds began to gather around Merwan, referring to Him as “Meher Baba”, which means “Compassionate Father.”  Meher Baba trained these early disciples over the coming years as He began to carry out His universal mission. Meher Baba and His close disciples maintained a lifestyle of purity and high moral standards. In May of 1923, Meher Baba first came here to Meherabad with some of those early disciples.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 4
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_next")])], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "left": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 2
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_before")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "4"
    }
  }, [_c('div', {
    attrs: {
      "id": "container"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "src": "/static/doc-images/lists/bio4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Baba Using Alphabet Board - May 19, 1932")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-height": "200px",
      "overflow-y": "auto"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Within two years this place became a thriving colony whose residents followed a disciplined life, exemplary of Baba’s motto “Mastery in Servitude”. By Meher Baba’s direction, a hospital and dispensary, and schools were established providing a variety of free services to the needy local population, irrespective of caste, creed, or religion.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("On July 10, 1925 Meher Baba began His great long silence here, which He maintained for the rest of His life. This was not undertaken as a spiritual exercise but rather, a limitation He assumed for the benefit of humanity. For many years He communicated by pointing to the letters on an alphabet board. In 1954, He deepened His Silence by giving up the board, & communicating through His unique, eloquent hand gestures and expressions. However, in His Silence Meher Baba gave unparalleled discourses and explanations concerning the spiritual Truths of the universe.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 5
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_next")])], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "left": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 3
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_before")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "5"
    }
  }, [_c('div', {
    attrs: {
      "id": "container"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "src": "/static/doc-images/lists/bio5.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Meher Baba, New York - 1932")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-height": "200px",
      "overflow-y": "auto"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Through the years, Meher Baba was unconcerned about the opposition to Him from various religious communities: “I belong to no religion. Every religion belongs to me. My own personal religion is of my being the Ancient Infinite One, and the religion I teach to all is of love for God.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Beginning in 1931 Meher Baba began a series of world travels contacting thousands and ‘laying cables’ for His spiritual work.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 6
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_next")])], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "left": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 4
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_before")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "6"
    }
  }, [_c('div', {
    attrs: {
      "id": "container"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "src": "/static/doc-images/lists/bio6.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Baba Feeding a Mast")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-height": "200px",
      "overflow-y": "auto"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("An important part of Meher Baba’s work through the years was to personally contact and serve hundreds of advanced pilgrims on the spiritual path called “masts”. These are advanced souls who have become spiritually intoxicated from direct awareness of God. Baba traveled many thousands of miles to remote places throughout the Indian sub-continent working to advance the masts spiritually and to engage them in His work which would benefit humanity.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 7
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_next")])], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "left": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 5
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_before")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "7"
    }
  }, [_c('div', {
    attrs: {
      "id": "container"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "src": "/static/doc-images/lists/bio7.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Meher Baba with New\r\n\t\t\t\t\t\t\t   Life Companions - 1949")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-height": "200px",
      "overflow-y": "auto"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("1949 Meher Baba went with a few companions on what He called ‘the New Life’ of complete renunciation, absolute helplessness & sole reliance on God. By living this New Life, which included wandering and begging phases, Meher Baba became the ordinary seeker on behalf of all humanity, and along with His companions, re-established the clear path to God.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 8
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_next")])], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "left": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 6
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_before")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "8"
    }
  }, [_c('div', {
    attrs: {
      "id": "container"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "src": "/static/doc-images/lists/bio8.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Baba in Switzerland - 1952")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-height": "200px",
      "overflow-y": "auto"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("During the 1950s Meher Baba travelled three more times to the West and visited Centres in America and Australia that were prepared for Him there. In 1952 in America, and in 1956 near Satara, India, Meher Baba was injured in two serious automobile accidents. He explained that in each advent the Avatar takes on physical and spiritual suffering as part of the work He does for humanity.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 9
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_next")])], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "left": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 7
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_before")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "9"
    }
  }, [_c('div', {
    attrs: {
      "id": "container"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "src": "/static/doc-images/lists/bio9.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Meher Baba, Mass Darshan - 1965")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-height": "200px",
      "overflow-y": "auto"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("During the mid-1950s Meher Baba travelled to different parts of India to give mass darshan programs to over a million people, sowing His love deep in their hearts. Through the 1960s Meher Baba continued to do His Universal Spiritual Work, often fasting in strict seclusion just as He had done since the early years of His mission.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 10
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_next")])], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "left": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 8
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_before")])], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "10"
    }
  }, [_c('div', {
    attrs: {
      "id": "container"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "src": "/static/doc-images/lists/bio10.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(" Meher Baba's Tomb (Samadhi) Meherabad, India")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-height": "200px",
      "overflow-y": "auto"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The purpose of Meher Baba’s life was to fulfill His work of giving the great ‘spiritual push’ to the universe.  In July of 1968 Meher Baba announced that He had completed His work 100% to His satisfaction, but His health was shattered, and on 31st January 1969, Meher Baba dropped His physical form to live eternally in the hearts of all who love Him. In keeping with His directive, His body was brought to Meherabad and placed in His Tomb-Shrine.  Today, Meher Baba’s Tomb is a site of world pilgrimage to thousands who come to pay homage to the Avatar of the Age.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 1
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_next")])], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "pink",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "left": "",
      "fab": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.e1 = 9
      }
    }
  }, [_c('v-icon', [_vm._v("navigate_before")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9cf9882a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bio.vue
// module id = 317
// module chunks = 1